import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { Terminals } from 'src/app/shared/interface/terminals';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {TerminalsImportRow} from "../../../shared/interface/terminals-import-row";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TerminalsService} from "../../../shared/services/terminals.service";
import {delay, takeUntil} from "rxjs/operators";
import {Partner} from "../../../shared/interface/partner";
import {HttpErrorResponse} from "@angular/common/http";


export interface ChangeTerminalsImportRowDialogData {
  terminalsObject: Terminals;
}
@Component({
  selector: 'app-change-terminals-import-row-dialog',
  templateUrl: './change-terminals-import-row-dialog.component.html',
  styleUrls: ['./change-terminals-import-row-dialog.component.scss']
})
export class ChangeTerminalsImportRowDialogComponent implements OnInit, OnDestroy  {

  changeTerminalImportRowForm: FormGroup;
  terminalsObject: TerminalsImportRow;
  processingRequest = false;
  terminalImportRowControl: FormControl;
  enableSaveButton = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<ChangeTerminalsImportRowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeTerminalsImportRowDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private terminalsService: TerminalsService,
    private snack: MatSnackBar
  ) {
    this.terminalsObject = data.terminalsObject;
      this.changeTerminalImportRowForm = fb.group({
        terminalsImportRow: this.terminalImportRowControl = fb.control('', [Validators.required ]),
      });
  }


  ngOnInit(): void {
    this.changeTerminalImportRowForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeTerminalImportRowForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  sendForm(): void {
    this.processingRequest = true;

    this.terminalsService.changeTerminalsImportRow(this.changeTerminalImportRowForm.value, this.terminalsObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono transakcję', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        if (error.status === 400) {
          this.snack.open(error.error.error.text, error.status.toString(), {
            duration: 2000,
          });
        } else {
          this.snack.open('Podczas aktualizacji obiektu polisy wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }


      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
